import { render, staticRenderFns } from "./ZohoAddAttachmentToRecord.vue?vue&type=template&id=72ebfc4a"
import script from "./ZohoAddAttachmentToRecord.vue?vue&type=script&lang=js"
export * from "./ZohoAddAttachmentToRecord.vue?vue&type=script&lang=js"
import style0 from "./ZohoAddAttachmentToRecord.vue?vue&type=style&index=0&id=72ebfc4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports